import { Component, computed, inject } from '@angular/core';
import { Router } from '@angular/router';
import { CartLine, CartService } from '../../services/cart.service';
import { Item } from '../../models/menu.model';
import { DataService } from '../../services/data.service';
import { VenueType } from '../../shared/enums';

@Component({
  selector: 'app-cart-block',
  templateUrl: './cart-block.component.html',
  styleUrl: './cart-block.component.scss',
  standalone: false,
})
export class CartBlockComponent {
  private readonly cartService = inject(CartService);
  private readonly router = inject(Router);
  private readonly dataService = inject(DataService);

  public readonly quantity = computed(() =>
    this.cartService.cartLines().reduce((sum, line) => sum + line.quantity, 0));

  public readonly isVisible = computed(() =>
    this.quantity() > 0 && this.dataService.restaurant()?.type !== VenueType.ReadOnly);

  public readonly totalPrice = computed(() =>
    this.cartService.cartLines().reduce((sum, line) => sum + this.lineTotal(line), 0));

  public openCart(): void {
    this.router.navigate(['/cart']);
  }

  private lineTotal(line: CartLine): number {
    const modifiersTotal = line.modifiers
      .reduce((sum, mod) => sum + this.modifierPrice(line.item, mod.id) * mod.quantity, 0);

    return (line.item.price + modifiersTotal) * line.quantity;
  }

  private modifierPrice(item: Item, modifierId: string): number {
    return item.modifier_groups
      .flatMap(group => group.modifiers)
      .find(modifier => modifier.id === modifierId)?.price ?? 0;
  }
}
